import styled from '@emotion/styled';

export const SHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
`;
